import { ConnectorFormDetails, Input, Label } from "@simplicity/ui";
import { TablesEditor, type Schedules, type TableConfig } from "../tables";
import type { ConnectorFormProps } from "./GenericVarsForm";

function TextField(props: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}) {
  return (
    <div className="flex-1">
      <Label htmlFor={props.id} className="form-label">
        {props.label}
      </Label>
      <Input
        id={props.id}
        type="text"
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        placeholder={props.placeholder}
        className="font-mono"
      />
    </div>
  );
}

export function SftpServerForm(props: ConnectorFormProps) {
  const tables = Array.isArray(props.vars.tables) ? (props.vars.tables as TableConfig[]) : [];
  const raw = props.vars.schedules;
  const schedules = (
    raw != null && typeof raw === "object" && !Array.isArray(raw) ? raw : {}
  ) as Schedules;

  const siteName = (props.vars.siteName as string) ?? "";
  const sftpUsername = (props.vars.sftpUsername as string) ?? "";
  const gcsBucketOverride = (props.vars.gcsBucketOverride as string) ?? "";
  const gcsPrefixOverride = (props.vars.gcsPrefixOverride as string) ?? "";
  const bronzeDataset = (props.vars.bronzeDataset as string) ?? "";
  const silverDataset = (props.vars.silverDataset as string) ?? "";

  function updateField(key: string, value: string) {
    const next = { ...props.vars };
    if (value) {
      next[key] = value;
    } else {
      delete next[key];
    }
    props.onVarsChange(next);
    props.clearBanner();
  }

  return (
    <>
      <div className="flex gap-4">
        <TextField
          id="sftp-site-name"
          label="Site Name"
          value={siteName}
          onChange={(v) => updateField("siteName", v)}
          placeholder="SFTP site name"
        />
        <TextField
          id="sftp-username"
          label="SFTP Username"
          value={sftpUsername}
          onChange={(v) => updateField("sftpUsername", v)}
          placeholder="SFTP username"
        />
      </div>
      <TablesEditor
        tables={tables}
        schedules={schedules}
        onChange={(change) => {
          props.onVarsChange({ ...props.vars, ...change });
          props.clearBanner();
        }}
        connectorType={props.connectorType}
        connectorId={props.connectorId}
      />
      {!props.hideAdvanced && (
        <ConnectorFormDetails
          summary="Advanced Options"
          className="mt-4 rounded border border-border/50"
        >
          <div className="flex gap-4">
            <TextField
              id="sftp-gcs-bucket"
              label="GCS Bucket Override"
              value={gcsBucketOverride}
              onChange={(v) => updateField("gcsBucketOverride", v)}
              placeholder="Optional — override derived bucket"
            />
            <TextField
              id="sftp-gcs-prefix"
              label="GCS Prefix Override"
              value={gcsPrefixOverride}
              onChange={(v) => updateField("gcsPrefixOverride", v)}
              placeholder="Optional — override derived prefix"
            />
          </div>
          <div className="flex gap-4">
            <TextField
              id="sftp-bronze-dataset"
              label="Bronze Dataset"
              value={bronzeDataset}
              onChange={(v) => updateField("bronzeDataset", v)}
              placeholder={`Default: bronze__${props.connectorPrefix}`}
            />
            <TextField
              id="sftp-silver-dataset"
              label="Silver Dataset"
              value={silverDataset}
              onChange={(v) => updateField("silverDataset", v)}
              placeholder={`Default: silver__${props.connectorPrefix}`}
            />
          </div>
        </ConnectorFormDetails>
      )}
    </>
  );
}
